var map = {
	"./pasta 1.png": 2140,
	"./pasta 10.png": 4151,
	"./pasta 11.png": 6721,
	"./pasta 12.png": 5360,
	"./pasta 13.png": 6270,
	"./pasta 14.png": 8372,
	"./pasta 15.png": 3861,
	"./pasta 16.png": 4105,
	"./pasta 17.png": 1337,
	"./pasta 18.png": 3631,
	"./pasta 19.png": 9577,
	"./pasta 2.png": 9836,
	"./pasta 20.png": 8867,
	"./pasta 21.png": 7961,
	"./pasta 22.png": 3632,
	"./pasta 23.png": 4194,
	"./pasta 24.png": 6221,
	"./pasta 25.png": 1991,
	"./pasta 3.png": 6102,
	"./pasta 4.png": 8260,
	"./pasta 5.png": 875,
	"./pasta 6.png": 6934,
	"./pasta 7.png": 3362,
	"./pasta 8.png": 354,
	"./pasta 9.png": 2330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2111;